export default {
    control: {
        backgroundColor: 'transparent',
        padding: '8.5px 14px',
    },
    input: {
        border: 0,
        borderRadius: '8px',
        boxShadow: 'none',
        margin: 0,
        outline: 'none',
        padding: '8.5px 14px',
    },
};
